import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import { Icon } from '@scentregroup/ui'
import { NavigationMenuGroupType } from '../../../../components/header/types'
import analyticsUtils from '../../../../helpers/analytics-utils'
import style from './index.scss'

class NavigationGroup extends Component {
  state = {
    closed: true,
  }

  handleMobileCategoryClick = () => {
    this.setState({
      closed: !this.state.closed,
    })
  }

  handleClick = subCategory => () => {
    const data = {
      event: analyticsUtils.events.SELECT_CATEGORY,
      eventCategory: analyticsUtils.categories.CATEGORY_SELECTION,
      eventAction: 'Header',
      categoryT1: this.props.navigationGroup.title,
    }
    if (subCategory) {
      data.categoryT2 = subCategory
    }
    analyticsUtils.gaTagTracking(data)
    this.props.onItemClick()
  }

  render() {
    return (
      <div className={style.navigationGroup}>
        <button
          className={classNames(style.mobileCategory, 'collapsable')}
          onClick={this.handleMobileCategoryClick}
        >
          {this.props.navigationGroup.title}
          <Icon
            type={this.state.closed ? 'chevron-down' : 'chevron-up'}
            size="small"
            className={classNames(style.navigationCarrot, 'collapsable')}
            role="presentation"
          />
        </button>
        <div
          className={classNames({ [style.disableMobile]: this.state.closed })}
        >
          <div className={style.mainCategoryWrapper} role="menu">
            <Link
              to={this.props.navigationGroup.url}
              className={style.mainCategory}
              onClick={this.handleClick()}
            >
              {this.props.navigationGroup.title}
            </Link>
          </div>
          {this.props.navigationGroup.items.map(item => (
            <div key={item.url} className={style.childrenWrapper} role="menu">
              <Link
                key={item.url}
                to={item.url}
                className={style.subCategory}
                aria-label={`Go to ${item.label}`}
                onClick={this.handleClick(item.label)}
              >
                {item.label}
              </Link>
            </div>
          ))}
        </div>
      </div>
    )
  }
}

NavigationGroup.propTypes = {
  navigationGroup: NavigationMenuGroupType.isRequired,
  onItemClick: PropTypes.func.isRequired,
}

export default NavigationGroup
